import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import types from '../../types';
import {
    Dropdown,
} from 'react-bootstrap';
import Select from 'react-select';
import { openModal, updateValueModal, closeModal } from '../../actions/modal.action';
import { useParams } from 'react-router-dom';
import { getSectionNameByCodeAndSurvey } from '../../actions/helpers/section.helper';

const MoveQuestionToSection = ({ questionId, identifier }) => {
    const dispatch = useDispatch();
    const { id: surveyId } = useParams();
    const { surveys } = useSelector((state) => state.surveySummary);
    const { allSections } = useSelector((state) => state.sections);
    const [sections, setSections] = useState([]);

    const handleSectionChange = (selectedOption) => {
        updateValueModal({
            sectionCode: selectedOption?.value,
            sectionName: selectedOption?.name,
            identifier,
            surveyId,
        })(dispatch);
    };

    const onMoveHandle = () => {
        openModal({
            className: 'modal-alert-width',
            button1Text: 'Cancel',
            button1Action: 'closeModal',
            button2Text: 'Move',
            hasValue: true,
            button2Action: (value) => {
                dispatch({
                    type: types.reducerTypes.UPDATING_SECTION_ON_QUESTION,
                    payload: {
                        section: value,
                        questionId
                    }
                });
                closeModal()(dispatch);
            },
            body: <>
                <Select
                    isClearable
                    className="w-100"
                    placeholder="Select Original Author"
                    isSearchable
                    closeMenuOnSelect={true}
                    options={sections.map((section) => ({
                        label: `${section.code} - ${section.name}`,
                        value: section.code,
                        name: section.name,
                    }))}
                    onChange={handleSectionChange}
                />
            </>,
        })(dispatch);
    };


    useEffect(() => {
        if (surveyId && surveys?.length) {
            const survey = surveys.find((s) => Number(s.id) === Number(surveyId));
            if (survey) {
                const sections = survey.surveySummaryDetailsDto?.sectionCodes
                    .split(',')
                    .sort((a, b) => {
                        if (a === b) {
                            return 0;
                        }
                        return a < b ? -1 : 1;
                    })
                    .map((code) => {
                        const selectedSectionCode = code.trim().toLowerCase();
                        const sectionName = getSectionNameByCodeAndSurvey(
                            selectedSectionCode,
                            survey,
                            allSections
                            
                        );
                        return {
                            name: sectionName,
                            code: selectedSectionCode,
                        };
                    });
                setSections(sections);
            } else {
                setSections([]);
            }
        }
    }, [surveyId, surveys, allSections]);

    return (
        <Dropdown.Item onClick={onMoveHandle}> Edit Question </Dropdown.Item>
    );
};

export default MoveQuestionToSection;
